import { Box, Button, Typography } from "@mui/material";
import { useQuery } from "react-query";
import StatsCard from "src/components/common/StatsCard";
import {
  getDashboardDetails,
  getLandDashboardDetails,
  getTableDashboardDetails,
} from "src/utils/api/dashboard";
import defaultStyles, { StylesClasses } from "../styles";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { getStyles } from "src/styles/theme";
import StatusBarChart from "src/components/common/StatusBarChart";
import {
  exportEntityTableToXlsx,
  exportTableToXlsx,
  formatDataForBarChart,
} from "src/utils/helper";
import { Collapse } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { useState } from "react";
import { DashBoardTable } from "src/components/common/DashboardTable/costEstimateTable";
import { AxiosResponse } from "axios";
import { EntityDashBoardTable } from "src/components/common/DashboardTable/entityDashboard";

const EntityDashboard = () => {
  const [tableRows, setTableRows] = useState([]);

  const [tableState, setTableState] = useState(false);

  const [queryParams, setQueryParams] = useState<{
    projectStateIds?: string[];
    type: string;
  }>({
    projectStateIds: undefined,
    type: "entityLandOwnership",
  });

  const [isTabLoading, setIsTabLoading] = useState(true);

  const { data: tableDashboard, isLoading } = useQuery(
    ["table-landOwnership", queryParams],
    () => getTableDashboardDetails(queryParams),
    {
      onSuccess: (res: AxiosResponse) => {
        setTableRows(
          res?.data?.stats.map((items, idx) => ({
            id: idx,
            sno: idx + 1,
            state: items.state,
            totalArea: items.totalArea,
            totalNumber: items.totalNumber,
            totalAreaDemandNotePending: items.totalAreaDemandNotePending,
            totalNumberDemandNotePending: items.totalNumberDemandNotePending,
            totalAreaPaymentPending: items.totalAreaPaymentPending,
            totalNumberPaymentPending: items.totalNumberPaymentPending,
            totalAreaApproved: items.totalAreaApproved,
            totalNumberApproved: items.totalNumberApproved,
            totalAreaDeselect: items.totalAreaDeselect,
            totalNumberDeselect: items.totalNumberDeselect,
          }))
        );
        setIsTabLoading(false);
      },
      onError: () => {},
      refetchOnMount: true,
    }
  );

  const dashboardTableData: DashBoardTable = {
    topHeader: [
      "",
      "ALL SELECTED",
      "DEMAND NOTE PENDING",
      "PAYMENT PENDING",
      "PAYMENT DONE",
      "DESELECTED",
    ],
    header: [
      "S.No",
      "State",
      "No",
      "Area (ha)",
      "No",
      "Area (ha)",
      "No",
      "Area (ha)",
      "No",
      "Area (ha)",
      "No",
      "Area (ha)",
    ],
    data: tableRows,
  };

  const { data: dashboard, isLoading: dashboardLoading } = useQuery(
    ["landDashboard"],
    () => getLandDashboardDetails(),
    {
      onSuccess: () => {},
      onError: () => {},
      refetchOnMount: true,
    }
  );
  const styles = getStyles(defaultStyles);

  const formattedData = formatDataForBarChart(dashboard?.data?.stats);

  return (
    <>
      <Box {...styles("topHeader")}>
        {!dashboardLoading ? (
          <Box
            sx={{ width: "100%", marginBottom: "20px", alignSelf: "center" }}
          >
            <StatusBarChart
              data={formattedData}
              label={"Status of Cost Estimates of Eco-Restoration Blocks"}
            />
          </Box>
        ) : (
          <></>
        )}
        <Box {...styles("statsCardWrapper")}>
          {dashboard?.data?.stats.map((stat, index) => (
            <StatsCard
              key={index}
              title={`${stat.description.toUpperCase()}`}
              value={`${stat?.number}`}
              area={stat?.totalArea}
              customStyles={{ valueCard: styles("statsCard").sx }}
            />
          ))}
        </Box>
      </Box>
      <Box {...styles("dashboardTableWrapper")}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h5" {...styles("heading")}>
            Status of Demand Note and Payment
          </Typography>
          <Button variant="outlined" onClick={() => setTableState(!tableState)}>
            {tableState ? (
              <>
                Compress
                <ArrowUpwardIcon sx={{ marginLeft: "10px" }} />
              </>
            ) : (
              <>
                Expand
                <ArrowDownwardIcon sx={{ marginLeft: "10px" }} />
              </>
            )}
          </Button>
        </Box>
        <Collapse in={tableState}>
          <Button
            variant="outlined"
            onClick={() =>
              exportEntityTableToXlsx(
                dashboardTableData.data,
                dashboardTableData.header,
                dashboardTableData.topHeader
              )
            }
            sx={{ float: "right", marginBottom: "20px" }}
          >
            Export
          </Button>
          <EntityDashBoardTable {...dashboardTableData} />
        </Collapse>
      </Box>
    </>
  );
};

export default EntityDashboard;
